<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool">
      <template slot="btn">
        <Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button>
          <Button @click="openAdd" type="primary" class="chaxun">新增</Button>
          <Button v-if="false" @click="piliang" type="primary" class="chaxun">piliang</Button>
        </template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" :disabled="row.isTransferKhbj == 1" @click="opemZhuanchu(row, index)">转客户报价</Button>
        <Button size="small" @click="taitou(row, index)">导出</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :overAuto="true" :title="isAdd ? '新增数据' : '编辑数据'" width="1200" ref="formModel" @tab="now = $event"
      :fullscreen="true">
      <div v-if="false" style="margin-bottom: 20px" slot="endcontent">
        <Tag>选择基础报价模板</Tag>
        <Select @on-change="getTemplate" style="width: 200px">
          <Option v-for="(x, index) in priceTemplateData" :key="index" :label="x.name" :value="index">{{ x.name }}
          </Option>
        </Select>
      </div>
      <baojia v-if="openBaojia" slot="endcontent" ref="baojia">
      </baojia>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <taitou ref="taitou"></taitou>
  </div>
</template>
<script>
var kehuitems = [];
import baojia from "./baojia.vue";
import taitou from "./taitou.vue";
export default {
  components: { baojia, taitou },
  data() {
    return {
      isAdd: false,
      openForm: false,
      now: "",
      columns: [
        { type: "index", width: 70 },
        {
          title: "操作",
          slot: "action",
          width: 220,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        cid: "",
        customer: "",
        contact: "",
        carType: "3T吨车",
        bpMode: 1,
        weight: 0,
        volume: 0,
        currency: "人民币",
        tel: "",
        priceTemplet: "",
        sendTime: Date.now() + 86400000,
        remark: "",
        //filesPath:''
      },

      searchItem: {
        keyword: "",
        cid: '',
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "客户名称",
          key: "cid",
          key2: "customer",
          required: true,
          val: "",
          type: "Select",
          selectType: "obj",
          selectItems: kehuitems,
          span: 8,
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          type: "Input",
          span: 8,
        },
        /* {
          title: "word模板",
          key: "filesPath",
          type: "word",
        }, */
      ],

      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "客户名称",
          key: "cid",
          selectItems: kehuitems,
          type: "Select",
          selectType: "obj",
        },
      ],
      priceTemplateData: [],
      openBaojia: false
    };
  },
  //http://59.37.161.185:8090/#/locate?now=1
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-smm/sellQuotation/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].sendTime2 = this.utils.time(data[i].sendTime, "yymmddhhmm");
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
        }
        console.log(data);
        this.tableData = data;
      });
    },
    addUpdate(name) {
      //var table = this.$refs.sellQuotationChargesList.yanzheng();

      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      var aaa = this.utils.findObj(kehuitems, "id", a.cid);
      this.item.customer = aaa.name;
      this.item.priceTemplet = this.$refs.baojia.getVal();
      console.log(this.item.priceTemplet);

      this.utils.loading(this, "提交中");
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-smm/sellQuotation/add",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-smm/sellQuotation/update",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-smm/sellQuotation/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
      this.openBaojia = true;
      this.getPriceTemplatList();
      setTimeout(() => {
        this.$refs.baojia.reach(this.item.priceTemplet);
      }, 200);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
      this.getPriceTemplatList();
      this.openBaojia = true;
      setTimeout(() => {
        this.$refs.baojia.reach('');
      }, 200);

    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    kehuList() {
      kehuitems.splice(0, 1000);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          kehuitems.push(obj);
        }
      });
    },
    getPriceTemplatList() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-smm/priceTemplet/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        this.priceTemplateData = data;
      });
    },
    getTemplate(v) {
      this.item.priceTemplet = this.priceTemplateData[v].content;
      this.$refs.baojia.reach(this.item.priceTemplet);
    },
    opemZhuanchu(row) {
      this.$Modal.confirm({
        title: "是否转为客户报价",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort +
              "/cloud-tms-server-smm/sellQuotation/transferKhbj",
            data: { id: row.id },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    taitou(v) {
      this.$refs.taitou.reach(v);
      return;
      var params = [
        {
          name: "id",
          value: v.id,
        },
      ];
      this.utils.exportData(
        this.axios.ipPort + "/cloud-tms-server-smm/sellQuotation/exportWord",
        params
      );
      //https://cloud.ly-gps.com/cloud-tms-server-smm/sellQuotation/exportWordy?accessToken=lNoUulMhI7ZlpXk09I63Vz88qY00ZIR4PxGWGt%252Fd6OQmceGOe4Kv4GHnUDK7UYE1%252BmzjuBT%252FzLSMltjZFUr%252B8zrezb4SRu3B%252FiA%252Bm3fp4pJntGdoXrJNs805i8V1eRY55x6rjDa7b%252Bp%252F91afbILL%252FdB%252F%252BFZ3%252B1UTgqlri2faB%252BZPsJAWmJ2x1Fn7%252BxTVqcEbyplNhr18yMwOd0IC8Fe2GWaBpm%252FB0tSUkScMzjai5JaCwyZbjZgvIKYbXfAIj70LyL7qR4Kx0GR2YKlwKiUx5e7WcHRntnqOIvMSHpwGKiNlMrMxBwm5jj%252BOHWqI7VGc3iYUY3CakGZNxzFiyaBo2Q%253D%253D&id=22
      //this.$refs.taitou.reach(v);
      ///cloud-tms-server-smm/sellQuotation/exportWord
    },
    exportAll() { },
    piliang() {
      var dataList = this.tableData;
      var length=8;
      for (let i = 10; i < length; i++) {
        let list = dataList[i].priceTemplet.zhuanche.list;//找到模板的专车模块
        for (let j = 0; j < list.length; j++) {
          list[j].unit = ['KGS', 'CBM', 'P/L', 'P/L1']
        }
        //数据改好了，提交编辑
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-smm/sellQuotation/update",
          data: dataList[i],
        }).then((res) => {
          console.log(res);
        });
      }
    }
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.kehuList();
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/yewubaojia.vue